export default {
  auditor: null,
  assignee: null,
  uuid: null,
  stimuli: null,
  sessions: [],
  startedAt: null,
  finishedAt: null,
  isSaved: false,
};


// WEBPACK FOOTER //
// ./src/modules/randomRotation/vuex/state.js